/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2019-10-24.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2019-10-24.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2019-10-24.mdx';

const metadata = {
  slug: "2019-10-24",
  title: "Two Years in NYC",
  author: "Christian Battaglia",
  description: "Nearing two years in New York — from New Year's in Colorado to a Bergdorf modeling gig, Book of Mormon on Broadway, and the evolution of my work at Amplify with Rust and OpenResty.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2019-10-24T00:00:00.000Z",
  
  readTime: "12 min read",
  tags: ["NYC","life update","Amplify","Rust","NGINX","OpenResty","Book of Mormon","career","Bergdorf"],
};

export const Route = createFileRoute('/blog/posts/2019-10-24')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2019-10-24',
    image: '/og/blog/2019-10-24.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
